<template>
  <div class="container md:flex">
    <slo-configure :hitsPerPage="12" />
    <section
      class="facets-container flex flex-wrap items-center justify-center py-xl pt-2xl md:block md:mr-lg"
    >
      <div class="row w-100 items-center justify-start mx-0 mb-md">
        <slo-tag-filter label="Products" attribute="product_category"></slo-tag-filter>
      </div>
      <div class="row w-100 mb-md sm:justify-between mx-0">
        <slo-finish-filter
          label="Color"
          attribute="colors"
          class="w-100 mb-md md:mb-0"
        ></slo-finish-filter>
        <slo-finish-filter
          label="Product Finish"
          attribute="finish"
          class="w-100"
        ></slo-finish-filter>
      </div>
      <div class="row w-100 justify-start mx-0">
        <slo-tag-filter label="Materials" attribute="materials"></slo-tag-filter>
      </div>
    </section>
    <slo-infinite-hits
      class="flex flex-wrap w-100 -mx-md pb-4xl md:mt-lg md:mx-0"
      :loaderProps="{ class: 'flex flex-wrap w-100' }"
    >
      <template v-slot:item="slotProps">
        <div class="col col-12 sm:col-6 lg:col-4 mt-lg">
          <RenderingCard
            v-bind="slotProps.item"
            :checked="selected.indexOf(slotProps.item.mid) > -1"
            @input="onInput($event)"
          />
        </div>
      </template>
      <template v-slot:loader>
        <div class="flex flex-wrap w-100">
          <div class="col col-12 sm:col-6 lg:col-4 mt-lg" v-for="i in 12" :key="i">
            <RenderingCard :loader="true" />
          </div>
        </div>
      </template>
      <template v-slot:no-results>
        <div class="mt-lg">
          {{ 'No image results found.' | t }}
        </div>
      </template>
    </slo-infinite-hits>
    <ais-state-results>
      <template v-slot="{ results }">
        <download-footer :total="results.nbHits" :selected="selected" @clear="onClear" />
      </template>
    </ais-state-results>
  </div>
</template>

<script>
import SloConfigure from '../../algolia/SloConfigure.vue';
import SloFinishFilter from '../../algolia/SloFinishFilter.vue';
import SloTagFilter from '../../algolia/SloTagFilter.vue';
import SloInfiniteHits from '../../algolia/SloInfiniteHits.vue';
import RenderingCard from '../components/RenderingCard.vue';
import DownloadFooter from '../components/DownloadFooter.vue';
import t from '../../main/i18n';

export default {
  data() {
    return {
      selected: []
    };
  },
  filters: {
    t
  },
  methods: {
    onClear() {
      this.selected = [];
    },
    onInput(id) {
      if (this.selected.indexOf(id) > -1) {
        this.selected = [...this.selected.filter(_id => _id !== id)];
      } else {
        this.selected = [...this.selected, id];
      }
    }
  },
  components: {
    RenderingCard,
    SloConfigure,
    SloFinishFilter,
    SloTagFilter,
    SloInfiniteHits,
    DownloadFooter
  }
};
</script>

<style lang="scss" scoped>
.loading {
  display: contents;
}
</style>

<style lang="scss" scoped>
.facets-container {
  max-width: 750px;

  @media screen and (min-width: 992px) {
    max-width: 350px;
    flex: 1 0 100%;
  }
}

.slo-tag-filter,
.slo-finish-filter {
  width: 100%;
}
</style>
